module.exports = __webpack_public_path__ + "static/media/M006-account-noprivilege.5723d20d.svg";